const type = 'UPDATE_ADVANCE_INVOICE_INSTALLMENT';

const updateAdvanceInvoiceInstallment = (data) => ({
  data,
  type,
});

export default updateAdvanceInvoiceInstallment;
